import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import servicesData from '../../data/servicesData';
import './ServicesPage.css';

const ServicesPage = () => {
    const navigate = useNavigate();

    return (
        <div className="services-page">
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: '10px',marginBottom: '32px'}}>
                <div style={{fontSize: '1.2rem', fontWeight: 'bold'}}>
                    Start your membership today!
                </div>
                <div>
                    <button style={{fontSize: '1.2rem', fontWeight: 'bold', backgroundColor: 'transparent', border: 'none', textDecoration: 'underline', cursor: 'pointer'}}>
                        <Link to="/memberships">
                            View Memberships
                        </Link>
                    </button>
                </div>
            </div>
            <div className="services-header">
                <h1>Our Services</h1>
                <p>Professional car detailing services tailored to your needs</p>
            </div>
            
            <div className="services-grid">
                {servicesData.map((service, index) => (
                    <div key={index} className={`service-card ${service.name.toLowerCase().replace(' ', '-')}`}>
                        <h2>{service.name}</h2>
                        {service.note && <p className="note">{service.note}</p>}
                        
                        {service.description.length > 0 && (
                            <div className="features">
                                <h3>Includes</h3>
                                <ul>
                                    {service.description.map((item, idx) => (
                                        <li key={idx}>{item.name}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        
                        {service.Add_On.length > 0 && (
                            <div className="add-ons">
                                <h3>Add-ons</h3>
                                <ul>
                                    {service.Add_On.map((addon, idx) => (
                                        <li key={idx}>
                                            {addon.name}
                                            {addon.price && <span>${addon.price}</span>}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            <div className="cta-section">
                <button 
                    className="book-now-btn"
                    onClick={() => navigate('/booking')}
                >
                    Book Now
                </button>
            </div>
        </div>
    );
};

export default ServicesPage;
